'use client';
import { CatTextareaField } from '@blocks-react/components/TextareaField';
import { BlocksChangeEvent } from '@blocks-web-components/events';
import { FC, PropsWithChildren } from 'react';
import { CatDescriptionProps } from '../types';
import { useController, useFormContext } from 'react-hook-form';
import clx from 'classnames';
export const RequestServiceDescription: FC<
  PropsWithChildren<CatDescriptionProps>
> = ({ ...descriptionProps }) => {
  const { getValues, setValue } = useFormContext();
  const { name, rules, classname } = descriptionProps;
  const { field, fieldState } = useController({ name, rules });
  const status = fieldState?.error ? 'error' : undefined;
  const note = fieldState?.error?.message;
  const onBlChange = (e: BlocksChangeEvent): void => {
    field.onChange(e);
    setValue(name, e.detail.value);
  };
  return (
    <div className={clx({ 'request-service-error': note })}>
      <CatTextareaField
        errorNote={note}
        status={status}
        value={getValues(name) ?? ''}
        onBlChange={onBlChange}
        {...descriptionProps}
        className={classname}
      />
    </div>
  );
};
